import React, { createContext, useContext, useState , useEffect} from "react";
import Cookies from "js-cookie";
import { useGlobalContext } from "./GlobalContext";
import { useForm } from "react-hook-form";
import { RxCross2 } from "react-icons/rx";
import { useAuthContext } from "./AuthContext";
import { io } from "socket.io-client";
const SOCKET_SERVER_URL = "https://fc-prod-testing.onrender.com";


export const ClientContext = createContext();
// Utility function for random color
export const ClientContextProvider = ({children}) =>{

    // state to open and close the create note modal
    const [isOpen,setIsOpen] = useState(false);
    const [isLoading , setIsLoading] = useState(false);
    const [notes , setNotes] = useState([]);

    const clientToken = Cookies.get('client_token');
    console.log(clientToken);
    const {reset} = useForm();
    const { baseUrl, openToast } = useGlobalContext();
    const {flowChangerToken} = useAuthContext();
    

    // function to close the create note modal
    const CloseNoteModal = () => {
        setIsOpen(false);
      };

    // function to generate random color
    // const getRandomColor = () => {
    //     const colors = ["#ffffcc", "#ccffcc", "#9dffb4", "#ffcccb", "#d1c4e9"]; // List of colors
    //     return colors[Math.floor(Math.random() * colors.length)];
    //   };
    //   function to generate random rotation
      const getRandomRotation = () => {
        const rotations = [-2, -1, 0, 1, 2]; // Possible rotation angles
        return rotations[Math.floor(Math.random() * rotations.length)];
      };
//   function to generate static notes
// const generateNotes = (count) => {
//     const generatedNotes = []
//     for (let i = 0; i < count; i++) {
//       generatedNotes.push({
//         title: `Note ${i + 1}`,
//         description: `This is the description for Note ${i + 1}.`,
//         color: getRandomColor(),
//         rotation: getRandomRotation(),
//         createdAt: new Date().toLocaleDateString(),
//       });
//     }
//     setNotes(generatedNotes);
//   };
//   post request function to create note

const createNote = async (data) => {
    try {
      const response = await fetch(baseUrl + "notes", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${clientToken}`,
        },
        body: JSON.stringify(data),
      });

      console.log(response);

      if (response.status === 201) {
        openToast("note has created successfully")
        reset();
        CloseNoteModal();
        getNotes();
      } else {
        const result = await response.json();
        console.log(result.message);
        openToast(result.message || "Internal server error", "error");
      }
    } catch (error) {
      console.log(error);
      openToast("Error while creating note", error);
    }
  };

  const getNotes = async () =>{
    if(!flowChangerToken) {
      setNotes([]); 
      setIsLoading(false); 
      return;
    }
    setIsLoading(true);
    try {
        const response = await fetch(baseUrl + "notes");
        const result = await response.json();
        console .log(result);
        if (response.status === 200) {
          setNotes(result)
        } else {
          console.log(result.message);
          setNotes([]);
        }
      }
      catch(error){
      console.log("error while fetching notes :" , error);
      setNotes([]);
      }
     finally{
        setIsLoading(false);
     } 
 }

 const DeleteNote =async (id) =>{
  try{
    const response = await fetch(`${baseUrl}notes/${id}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json", 
      },
    });
    const result = await response.json();
    if(response.status === 200){
      getNotes()
      openToast(result.message||"note is successfully deleted","success")
    }
    else {
      openToast(result.message||"note is not deleted","error");
      setNotes(notes);
    }
  }
  catch(error){
    openToast("error while deleting record",error)
    setNotes(notes);
  }
 }



 useEffect(()=>{
  getNotes();
 },[])

//  handling the chat section here
 const [socket, setSocket] = useState(null);
  const [messages, setMessages] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);
  const [message, setMessage] = useState("");
  const [currRoom, setCurrRoom] = useState(null);
  const [id, setId] = useState(null);
  const [notifications, setNotifications] = useState([]);
  const [showChatSection, setShowChatSection] = useState(false);
  const [showAnnouncementsModal, setShowAnnouncementsModal] = useState(false);
  const [showCreateGroupModal, setShowCreateGroupModal] = useState(false);
  const [AddMembersPanel, setShowAddMembersPanel] = useState(false);
  const [showDeleteGroupModal, setShowDeleteGroupModal] = useState(false);
  const [showAddMemberModal, setShowAddMemberModal] = useState(false);
  const [toggleSettings, setToggleSettings] = useState(false);
  const [isSendingMessage, setIsSendingMessage] = useState(false);
  const [clientData, setClientData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rowsToShow, setRowsToShow] = useState(25);
  const [selectedStaff, setSelectedStaff] = useState(null);
  const [savePaymentData, setSavePaymentData] = useState([]);
  const [selectBranch, setSelectBranch] = useState('')
  const [selectDepartments, setSelectDepartments] = useState('')

  //  handling the modals in clientchatInterface
  const handleToggleSettings = () => {
    setToggleSettings((toggleSettings) => !toggleSettings);
  };

  const handleAddMembersPanel = () => {
    setShowAddMembersPanel((AddMembersPanel) => !AddMembersPanel);
  };
  const handleAddMembersModal = () => {
    setShowAddMemberModal((showAddMemberModal) => !showAddMemberModal);
  };

  const handleAnnouncementsClick = () => {
    setShowAnnouncementsModal(true);
    setToggleSettings(false); // Close the settings menu when opening modal
  };
  const handleCreateGroupClick = () => {
    setShowCreateGroupModal(true);
    setToggleSettings(false); // Close the settings menu when opening modal
  };
  const handleDeleteGroupClick = () => {
    setShowDeleteGroupModal(true);
    // Close the settings menu when opening modal
  };

  const handleChangeBranch = (value) => {
    setSelectBranch(value);
    console.log(value);
    
  };

  const handleChangeDepartment = (value) => {
    setSelectDepartments(value);
  }

  const resetState = () => {
    setSelectBranch("")
    setSelectDepartments("")
  }

  useEffect(() => {
    if (Cookies.get("flowChangerAuthToken")) {
      const socketInstance = io(SOCKET_SERVER_URL);
      setSocket(socketInstance);

      socketInstance.on("connect", () => {
        socketInstance.emit("setup", {
          token: Cookies.get("flowChangerAuthToken"),
        });
      });

      return () => {
        socketInstance.disconnect();
      };
    }
  }, []);

   useEffect(() => {
       if (socket) {
         socket.on("message_received", (data) => {
           if (currRoom && data.roomId === currRoom.id) {
             setMessages((prevMessages) => [...(prevMessages || []), data]);
           } else {
             console.log("new notification", data.sender.id);
             setNotifications((prevNotifications) =>
               prevNotifications.includes(data.sender.id)
                 ? prevNotifications
                 : [...prevNotifications, data.sender.id]
             );
           }
         });
       }
   
       return () => {
         if (socket) socket.off("message_received");
       };
     }, [socket, currRoom]);

   const fetchOneOnOneChat = async (id) => {
     try {
       const response = await fetch(`${baseUrl}chat/${id}`, {
         method: "GET",
         headers: {
           Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
         },
       });
       console.log(response);
       if (!response.status == 200) {
         openToast(`Failed to fetch chat`, "error");
       } else {
         const room = await response.json();
         socket.emit("join_room", room.id);
         setCurrRoom(room);
         setId(room.userId);
         setMessages(room.messages ?? []);
       }
     } catch (error) {
       console.log(error);
       openToast("Something went wrong", "error");
     }
   };

const sendMessage = async () => {
    try {
      setIsSendingMessage(true);
      if (message != "") {
        console.log(message, currRoom.id);
        const response = await fetch(`${baseUrl}message/send`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
          },
          body: JSON.stringify({ content: message, roomId: currRoom.id }),
        });

        if (!response.status == 200) {
          openToast(`${(await response.json()).error}`, "error");
        } else {
          const { message, room, users } = await response.json();
          setMessages([...messages, message]);
          socket.emit("send_message", {
            message: message,
            room: room,
            users: users,
          });
        }
        setMessage("");
      }
    } catch (error) {
      openToast("Something went wrong", "error");
    } finally {
      setIsSendingMessage(false);
    }
  };

  const handleSelectedUser = (user) => {
    if (notifications.includes(user.id)) {
      notifications.splice(notifications.indexOf(user.id), 1);
    }
    setSelectedUser(user);
    setMessages(null);
    fetchOneOnOneChat(user.id);
    setShowChatSection(true);
  };
  // chat section code ends here
  return (
   <ClientContext.Provider value={{notes,createNote,clientToken,CloseNoteModal,isOpen,setIsOpen , getNotes , isLoading , getRandomRotation , DeleteNote}}>
    {children}
   </ClientContext.Provider>
  )    
}


  
export const useClientContext = () => {
    return useContext(ClientContext);
  };

  const colorPalette = [
    "#FFFFFF", // White
    "#E3E3E3", // Light Gray
    "#D9EFFF", // Light Blue
    "#FFE7F3", // Light Pink
    "#FFF4D9", // Light Yellow
    "#D9FFE4", // Light Green
    "#FFF0F0", // Pale Red
    "#F3EFFF", // Lavender
    "#E9E9E9", // Gray
  ];
  const ColorPalette = ({setShowColorPallate, selectedColor, onColorSelect }) =>{
    const handleColorClick = (color) => {
        // Select the clicked color
        onColorSelect(color);
      
    };
    return(
      <div className="p-4 bg-white rounded-lg shadow-lg m-auto w-64 h-64 absolute inset-0 border border-gray-400 colorpallate">
        <div className="flex justify-end text-[20px]">
    <RxCross2 className="-top-1" onClick={()=>{setShowColorPallate(false)}}/>
    </div> 
        <div className = "flex  items-center justify-center w-full">
    <h3 className="text-lg font-semibold mb-4 text-center">
      Theme Filter by Colour
    </h3>

    </div>
    {/* <button
      className="p-2 border border-black rounded-md w-full mb-4 text-center"
      onClick={() => console.log("Reset Filter")}
    >
      Reset
    </button> */}
    {/* Grid Layout */}
    <div className="grid grid-cols-5 gap-2 h-[20%]">
      {colorPalette.map((color, index) => (
        <button
          key={index}
          onClick={() => handleColorClick(color)}
          className={`w-full aspect-square rounded-md border h-[30px] ${
            selectedColor === color ? "border-black" : "border-gray-500"
          }`}
          style={{ backgroundColor: color }}
        >
          {/* Color Swatches */}
        </button>
      ))}
    </div>
  </div>
    )
   
  }

export default ColorPalette; 




  
  